import { useApiMutation } from "./use-api-mutation";

export type TestAlertingKind = "digest" | "technical";

export default function useTestAlerting(shopId: string) {
  return useApiMutation("post", "/shops/{shopId}/reporting/alerting/test", {
    notify: true,
    mapVariables: (
      variables: string | { email: string; kind: TestAlertingKind },
    ) => ({
      params: { path: { shopId } },
      body: typeof variables === "string" ? { email: variables } : variables,
    }),
  });
}
